import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  border-radius: 12px;
  text-align: left;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  font-size: 16px;

  @media (max-width: 768px) {
    gap: 12px;
    flex-direction: column;
    align-items: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

export const Link = styled.a`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #0058e6;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Title = styled.p`
  margin: 0;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  color: #2a5595;
`;

export const Description = styled.div`
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #575755;
`;
